'use client';

import React from 'react';
import { motion } from 'framer-motion';

const MenuColumn = (props: {
  children: React.ReactNode;
  delay?: number;
  direction: 'left' | 'right';
  isMobile: boolean;
}) => {
  const { children, delay = 0, direction, isMobile } = props;
  const initialX = isMobile ? 0 : direction === 'left' ? -20 : 20;

  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, x: initialX }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay, duration: 0.4 }}
    >
      {children}
    </motion.div>
  );
};

export default MenuColumn;
